import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Loader from "@/components/Loader";
import { useIsInternalUser } from "@/hooks/useIsInternalUser";
import { useCapabilityLanding } from "@/hooks/useCapabilityLanding";
import { useSnackbar } from "@/contexts/SnackbarContext";
import type { GuardProps } from "./types";

// Safe to use without its own isInitialized check — must always be nested inside AuthGuard.
function ExternalUserGuard({ children }: GuardProps) {
  const isInternal = useIsInternalUser();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { loading, destination } = useCapabilityLanding();

  useEffect(() => {
    if (isInternal || loading) return;
    showSnackbar("You don't have access to that page.", "warning");
    navigate(destination, { replace: true });
  }, [isInternal, loading, destination, navigate, showSnackbar]);

  if (isInternal) return <>{children}</>;
  // Holds instead of redirecting to a stale guess: `destination` is only
  // trustworthy once the user's capabilities have resolved.
  return loading ? <Loader /> : null;
}

export default ExternalUserGuard;
